const initialState = {
  collapsed: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case 'TOGGLE_COLLAPSE_STATE':
      return {
        ...state,
        collapsed: !state.collapsed,
      };

    default:
      return state;
  }
};
